import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const STTableCellTypography = styled(Typography)`
  && {
    color: black;
    font-weight: 400;
    font-size: 0.8125rem;
  }
`;
